module.exports = {
  messages: {
    CN: {
      infoTips: "为了让更好的训练AI，我们需要您录入以下内容：",
      FirstName: "姓",
      LastName: "名",
      role: "你的角色是？",
      Location: "区域",
      Submit: "提交",
      Solo: "个人创业者",
      SalesTeam: "销售团队",
      Recruiter: "招聘",
      Marketer: "市场人员",
      Agency: "机构",
      CustomEntry: "自定义",
      EnterRole: "输入你的角色",
      CompanyName: "公司名字",
      TeamSize: "团队规模",
      required: "该项为必填项",
      industry: "行业",
      selectInstry: "请选择您的行业",
      Enteryourindustry: "输入您的行业",
      Pleaseenteryourindustry: "请输入您的行业",
      Freelancer: "自由职业者",
    },

    US: {
      infoTips:
        "Unlock smarter AI conversations and accelerate your success by completing:",
      FirstName: "First Name",
      LastName: "Last Name",
      role: "What is your role?",
      Location: "Location",
      Submit: "Submit",
      Solo: "Solo entrepreneur",
      SalesTeam: "Sales team",
      Recruiter: "Recruiter ",
      Marketer: "Marketer",
      Agency: "Agency",
      CustomEntry: "Custom entry",
      EnterRole: "Enter your role",
      CompanyName: "Company name",
      TeamSize: "Team size",
      required: "The item is required",
      industry: "industry",
      Enteryourindustry: "Enter your industry",
      Pleaseenteryourindustry: "Please enter your industry",
      selectInstry: "Please select your industry",
      Freelancer: "Freelancer",
    },
    AR: {
      infoTips: "انطلق في محادثات ذكاء اصطناعي أذكى وسرّع نجاحك بإكمال:",
      FirstName: "الاسم الأول",
      LastName: "الاسم الأخير",
      role: "ما هو دورك؟",
      Location: "الموقع",
      Submit: "إرسال",
      Solo: "رائد أعمال فردي",
      SalesTeam: "فريق المبيعات",
      Recruiter: "مسؤول التوظيف",
      Marketer: "أخصائي التسويق",
      Agency: "وكالة",
      CustomEntry: "إدخال مخصص",
      EnterRole: "أدخل دورك",
      CompanyName: "اسم الشركة",
      TeamSize: "حجم الفريق",
      required: "هذا هو المطلوب",
      industry: "الصناعة",
      Enteryourindustry: "أدخل صناعتك",
      Pleaseenteryourindustry: "الرجاء إدخال صناعتك",
      selectInstry: "الرجاء اختيار مجال عملك",
      Freelancer: "مستقل",
    },
  },
};
